export const TELL_O_MESSAGES = {
  apply: "Apply",
  notThat: "Not that",
  doThat: "Do that",
  neverMind: "Never mind",
  undo: "Undo",
  undone: "Back to O's default.",
  dividers: "Dividers",
  loaders: "Spring loaders",
  both: "Both",
  neither: "Neither",
  give: "Give",
  takeAway: "Take away",
  useDepth: "Use {{depth}}",
  product: "product",
  products: "products",
  shelf: "shelf",
  shelves: "shelves",
  bay: "bay",
  bays: "bays",
  level: "Level {{level}}",
  positionTop: "the top shelf",
  positionTopMany: "top shelves",
  positionBottom: "the bottom shelf",
  positionBottomMany: "bottom shelves",
  positionNumber: "shelf {{position}}",
  groupTop: "the base planogram's top shelves",
  groupBottom: "the base planogram's bottom shelves",
  groupNumber: "the base planogram's shelf {{position}}",
  wide: ", {{value}} wide",
  deep: ", {{value}} deep",
  range: "{{low}} to {{high}}",
  productCount: "{{count}} of {{total}} products",
  shelfCount: "{{count}} of {{total}} shelves",
  counts: "{{products}}, {{shelves}}",
  shortCounts: "{{count}} of {{total}}, {{shelves}}",
  previewGet: "{{dividers}} of {{total}} shelves get dividers; {{loaders}} get spring loaders.",
  previewKeep: "{{dividers}} of {{total}} shelves get dividers; {{loaders}} keep spring loaders.",
  bothOnly: "Only {{group}} get dividers and spring loaders",
  bothAll: "Dividers and spring loaders for every product",
  bothExcept: "Dividers and spring loaders removed from {{group}}",
  bothAdd: "Dividers and spring loaders for {{group}} too",
  dividersOnly: "Only {{group}} get dividers",
  dividersAll: "Dividers for every product",
  dividersExcept: "Dividers removed from {{group}}",
  dividersAdd: "Dividers for {{group}} too",
  loadersOnly: "Spring loaders for {{group}} only",
  loadersAll: "Spring loaders for every product",
  loadersExcept: "Spring loaders removed from {{group}}",
  loadersAdd: "Spring loaders for {{group}} too",
  bothProductCounts:
    "{{dividers}} of {{total}} products get dividers, {{loaders}} get spring loaders",
  bothChange:
    "{{lead}}: {{products}}; {{dividers}} of {{total}} shelves get dividers, {{loaders}} get loaders.",
  dividerChange: "{{lead}}: {{counts}}{{width}}. Spring loaders unchanged.",
  loaderChange: "{{lead}}: {{counts}}{{depth}}. Dividers unchanged.",
  likeBase: "Dividers like the base planogram",
  noDividers: "No dividers",
  noLoaders: "No spring loaders",
  clearDividersEmpty: "No dividers on any shelf. Spring loaders unchanged.",
  clearDividers: "No dividers on any shelf. Spring loaders stay as they are: {{counts}}{{depth}}.",
  clearLoadersEmpty: "No spring loaders. Dividers unchanged.",
  clearLoaders: "No spring loaders. Dividers stay as they are: {{counts}}{{width}}.",
  instead: " instead of {{previous}}",
  widthChange: "Dividers {{width}} wide{{instead}}, same products: {{counts}}.",
  depthChange: "Spring loaders {{depth}} deep{{instead}}, same products: {{counts}}.",
  fewerFacings:
    "{{head}} Wider dividers take facings: about {{difference}} fewer per {{width}} {{unit}} shelf.",
  moreFacings:
    "{{head}} Narrower dividers free facings: about {{difference}} more per {{width}} {{unit}} shelf.",
  keepOn:
    "Same as now, and shelves whose store fixtures already have dividers keep them, even where no product needs one.",
  keepOff: "Shelves whose store fixtures have dividers no longer keep them; the products decide.",
  loaderProducts: "Spring loaders follow the products again: {{counts}}{{depth}}.",
  loaderShelvesEmpty:
    "No spring loaders on the base planogram's shelves, so none here. Dividers unchanged.",
  loaderShelves:
    "Spring loaders stay on the base planogram's {{count}} {{shelves}}{{depth}}, whatever the products need. Dividers unchanged.",
  shelfWhere: "Bay {{bayNo}} Shelf {{shelfNo}} in store {{storeCode}}{{base}}",
  baseStore: " (the base planogram's store)",
  shelfDividerRule: "{{where}} gets the rule's dividers again. Other shelves unchanged.",
  shelfDividerNever: "{{where}} gets no dividers, whatever the rule says. Other shelves unchanged.",
  shelfDividerAlways:
    "{{where}} gets dividers always, whatever the rule says. Other shelves unchanged.",
  shelfLoaderRule: "{{where}} follows the rule for spring loaders again. Other shelves unchanged.",
  shelfLoaderNone:
    "{{where}} gets no spring loader, whatever the products need. Other shelves unchanged.",
  shelfLoaderDepth:
    "{{where}} gets a {{depth}} spring loader, whatever the products need. Other shelves unchanged.",
  saved:
    "Saved for Bay {{bayNo}} Shelf {{shelfNo}} in store {{storeCode}}. Regenerate the store to refit the products.",
  shelfUndone: "Bay {{bayNo}} Shelf {{shelfNo}} follows the rule again.",
  cannotPosition:
    "{{feature}} follow products, not shelf positions, so O can't pick {{position}} in every store.",
  nearestPosition:
    "{{head}} Nearest thing: {{feature}} for the {{count}} {{products}} that {{sit}} on the base planogram's {{position}}.",
  sits: "sits",
  sit: "sit",
  oneStore: "A shelf is set by hand one store at a time.",
  nearestStore:
    "A shelf is set by hand one store at a time. Nearest thing: Bay {{bayNo}} Shelf {{shelfNo}} in store {{storeCode}}.",
  unknownProducts: "O can't find '{{phrase}}' in this category's products or groups.",
  notUnderstood: "O didn't follow that. Try one of these, or open Advanced settings.",
  bothModes: "Spring loaders either follow the products or stay with the shelf, not both.",
  shelfNotFound:
    "There is no Bay {{bayNo}} Shelf {{shelfNo}} on the base planogram ({{bays}} {{bayWord}}, up to {{shelves}} {{shelfWord}}).",
  depthTooDeep:
    "Spring loaders can't be {{depth}} deep: the shallowest shelf is {{shallowest}}. The deepest that fits is {{deepest}}.",
  readingGroup: "Read '{{phrase}}' as {{value}} ({{detail}}), {{count}} {{products}}.",
  readingName: "Read '{{phrase}}' as {{count}} {{products}} named {{word}}.",
  readingProduct: "Read '{{phrase}}' as {{product}}.",
  questionFeaturePhrase: "{{phrase}} ({{label}}, {{count}} {{products}}) for what?",
  questionFeature: "{{label}} ({{count}} {{products}}) for what?",
  questionWhich: "Which did you mean by '{{phrase}}'?",
  questionInOut: "'{{phrase}}': give them {{feature}}, or take theirs away?",
  questionShelf:
    "Bay {{bayNo}} Shelf {{shelfNo}} is set one at a time: dividers or spring loaders first?",
  groupOption: "{{label}} ({{count}})",
  chipKeep: "Keep the store's hardware",
  chipDoNotKeep: "Don't keep the store's hardware",
  chipLoaderProducts: "Loaders follow the products",
  chipLoaderShelf: "Loaders stay with the shelf",
  prefillWidth: "Dividers {{number}} {{unit}} wide",
  prefillDepth: "Spring loaders {{number}} {{unit}} deep for every product",
} as const;

export type TellOMessageKey = keyof typeof TELL_O_MESSAGES;
export type TellOMessageParams = Record<string, string | number>;
export type TellOTranslate = (key: TellOMessageKey, params?: TellOMessageParams) => string;

export const tellOEnglish: TellOTranslate = (key, params = {}) =>
  TELL_O_MESSAGES[key].replace(/\{\{(\w+)\}\}/g, (match, name: string) =>
    params[name] === undefined ? match : String(params[name]),
  );
